import { inject } from '@angular/core'
import { Company } from '@models/company.model'
import { ErrorMessage } from '@models/errorMessage.model'
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals'
import { CompanyService } from '@services/company.service'
import { SELECTED_COMPANY_KEY } from '@utils/storage.keys'

interface CompanyState {
  companies: Company[]
  isLoading: boolean
  initial: boolean
  filter: { query: string; order: 'asc' | 'desc' }
  error?: ErrorMessage
  selectedCompany: Company | null
}
const initialState: CompanyState = {
  companies: [],
  initial: true,
  isLoading: true,
  filter: { query: '', order: 'asc' },
  selectedCompany: null,
}

export const CompanyStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withMethods((store, companies$ = inject(CompanyService)) => ({
    safeStorageGet(key: string): string | null {
      try {
        return localStorage.getItem(key)
      } catch {
        return null
      }
    },
    safeStorageSet(key: string, value: string): void {
      try {
        localStorage.setItem(key, value)
      } catch {
        // ignore storage failures (Safari private mode, strict privacy settings)
      }
    },
    loadCompanies(callback: (companies: Company[]) => void): void {
      patchState(store, { isLoading: true, companies: [] })
      companies$.getMyCompanies().subscribe({
        next: (companies) => {
          callback(companies)
          patchState(store, { companies })

          const companyId = this.safeStorageGet(SELECTED_COMPANY_KEY)
          if (companyId) {
            this.setSelectedCompany(JSON.parse(companyId))
          } else {
            if (companies.length > 0) {
              this.setSelectedCompany(companies[0].id)
            }
          }
        },
        error: (error: ErrorMessage) => {
          console.error('err companies store', error)
          patchState(store, { error })
        },
        complete: () => patchState(store, { isLoading: false, initial: false }),
      })
    },
    setSelectedCompany(companyId: number) {
      const company = store.companies().find((c) => c.id === companyId)
      this.safeStorageSet(SELECTED_COMPANY_KEY, companyId.toString())
      patchState(store, { selectedCompany: company, initial: false })
    },
  })),
)
